/* unplugin-vue-components disabled */import { render } from "./TextHighlight.vue?vue&type=template&id=3207c2f6&ts=true"
import script from "./TextHighlight.vue?vue&type=script&lang=ts"
export * from "./TextHighlight.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__